import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import TipoVendaModel from "@/models/tipoVendaModel";
import tipoVendaService from "@/services/tipoVendaService";

import ListComponentBase from "../listComponentBase";

@Component
export default class TiposVendaListComponent extends ListComponentBase<TipoVendaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
            new GridColumn("utilizaValorCusto", this.$t("__.ts.utilizaValorCusto"), GridColumnType.Boolean),
            new GridColumn(
                "pontuaProgramaFidelidade",
                this.$t("__.ts.pontuaProgramaFidelidade"),
                GridColumnType.Boolean,
            ),
        ];
    }

    private beforeMount() {
        this.setPropsCached(tipoVendaService, "tipovenda", "descricao", true);
    }
}
